import { Injectable } from '@angular/core';
import { LayerContainerService } from './layer-container.service';
import { ConfigService } from '../../config/config.service';
import {EsriGroupLayer, EsriReactiveUtils} from '../../config/esri.module';

@Injectable({
  providedIn: 'root',
})
export class LayerListService {
  constructor(private layerContainerService: LayerContainerService, private configService: ConfigService) {}

  /**
   * @name getMainMapLayers
   * @description  Get subset of Layer Container for Main-Map, using
   * layer-list.config for filtering
   */
  public getMainMapLayers(): Array<any> {
    const _layerList: Array<__esri.Layer> = [];
    const lyrList = this.configService.layerListConfig.layerList;

    lyrList.forEach(layer => {
      if (layer.isGroupLayer) {
        const _groupLyr = this.createGroupLayer(layer);
        _layerList.push(_groupLyr);
      } else {
        const esriLayer = this.getEsriLayerFromContainer(layer.fkLayer);
        if (esriLayer) {
          esriLayer.visible = layer.visible;
          this.setWatchOnLyrVisibility(esriLayer);
          _layerList.push(esriLayer);
        }
      }
    });
    return _layerList;
  }

  /**
   * @name createGroupLayer
   * @description create groupLayer for toc from layerlist config,
   * using layer-container.config
   * @return groupLyr: esri GroupLayer
   */
  private createGroupLayer(groupLyrConfig: any): __esri.GroupLayer {
    let groupLyr: __esri.GroupLayer;
    const groupLayers: Array<__esri.Layer> = [];
    groupLyrConfig.layers.forEach(layer => {
      const esriLayer = this.getEsriLayerFromContainer(layer.fkLayer);
      this.setWatchOnLyrVisibility(esriLayer);
      if (esriLayer) groupLayers.push(esriLayer);
    });

    const groupLayerProperties: __esri.GroupLayerProperties = {
      title: groupLyrConfig.title,
      visible: groupLyrConfig.visible,
      visibilityMode: groupLyrConfig.visibilityMode,
      layers: groupLayers,
    };
    groupLyr = new EsriGroupLayer(groupLayerProperties);
    return groupLyr;
  }

  /**
   * @name getEsriLayerFromContainer
   * @description filter layercontainer config based on fkLayer from layelist config
   * @return esriLayer: esri layer
   */
  private getEsriLayerFromContainer(fkLayer: string): __esri.Layer {
    const lyrContainer = this.layerContainerService.layerList.map(f => f.esriLayer);
    return lyrContainer.filter(f => f.id === fkLayer)[0];
  }

  /**
   * @name setWatchOnLyrVisibility
   * @description  set watch on every layer in TOC
   * @param esriLyr
   */
  private setWatchOnLyrVisibility(esriLyr: __esri.Layer) {
    if (!esriLyr) {
      return;
    }
    EsriReactiveUtils.watch(
      () => esriLyr.visible,
      (value: boolean) => {
        this.onChangeLyrVisibility(esriLyr, value);
      }
    );

    if (esriLyr['sublayers']) {
      esriLyr['sublayers'].items.forEach(item => {

        EsriReactiveUtils.watch(
          () => item.visible,
          (valueItem: boolean) => {
            this.onChangeLyrVisibility(item, valueItem);
          }
        );
      });
    }
  }

  /**
   * @name onChangeLyrVisibility
   * @description  handle change visiblity on every layer in TOC
   * @param lyr
   * @param _visible
   */
  private onChangeLyrVisibility(lyr: __esri.Layer, _visible: boolean) {
    if (lyr['toolTip']) {
      this.setVisibilty(lyr, _visible);
    } else if (lyr['sublayers']) {
      lyr['sublayers'].items.forEach(item => {
        if (item['toolTip']) {
          this.setVisibilty(item, _visible);
        }
      });
    }
  }

  /**
   * @name setVisibilty
   * @description  set visibilty value on Layer in TOC
   * @param lyr
   * @param _visible
   */
  private setVisibilty(lyr: __esri.Layer, _visible: boolean) {
    const _lyr = this.layerContainerService.layerList.filter(f => f.esriLayer.id === lyr['toolTip'].fkLayer)[0];
    _lyr.esriLayer.visible = _visible;
  }
}
